export const MINI_STAT_WIN_GRADIENT = "linear-gradient(135deg, #06E363, #AAFAB1)";
export const MINI_STAT_LOSS_GRADIENT = "linear-gradient(135deg, #E00101, #FE4244)";
/** Neutral count / rate mini stats (win rate, trade counts). */
export const MINI_STAT_COUNT_GRADIENT = "linear-gradient(135deg, #38BBD1, #3EEAEC)";
/** Open / still-running paths — glacial orange (Trade Log warning tone). */
export const MINI_STAT_OPEN_GRADIENT = "linear-gradient(135deg, #f45b0b, #f49113)";

export function isNegativeFormattedAmount(amount: string): boolean {
  const trimmed = amount.trim();
  return (
    trimmed.startsWith("-") ||
    trimmed.startsWith("\u2212") ||
    trimmed.startsWith("(") ||
    /^[^0-9]*-/.test(trimmed) ||
    trimmed.includes("-$")
  );
}

export function isPositiveSignedAmount(amount: string): boolean {
  const trimmed = amount.trim();
  return trimmed.startsWith("+");
}

/**
 * Card tint for mini stat surfaces. Signed P&L amounts take precedence over
 * comparison percentage so a negative total still renders red when change is up.
 */
export function resolveMiniStatGradient(options: {
  amount: string;
  percentage: number | null;
  backgroundGradient?: string;
}): string {
  const { amount, percentage, backgroundGradient } = options;
  if (backgroundGradient) return backgroundGradient;

  if (isNegativeFormattedAmount(amount)) return MINI_STAT_LOSS_GRADIENT;
  if (isPositiveSignedAmount(amount)) return MINI_STAT_WIN_GRADIENT;

  if (percentage !== null) {
    return percentage >= 0 ? MINI_STAT_WIN_GRADIENT : MINI_STAT_LOSS_GRADIENT;
  }

  return MINI_STAT_WIN_GRADIENT;
}
